import { router, store } from '../plugins';
import { getPackageVersion } from '@/api/base';
import { getLocal, setLocal } from '@/utils/func';
const packageInfo = require('../../package.json');

router.beforeEach(async (to, from, next) => {
    const { state, getters, dispatch } = store,
        { name, meta } = to,
        menuBtns = getters['comon/menuBtns'],
        ignoreBtns = ['error'],
        ignoreDelIconBtns = ['home'];

    if (to.path === '/templates-add' && to.query.fromWeapp) {
        return next();
    }
    if (name) {
        let has = false;

        for (let ij = menuBtns.length - 1, item; ij >= 0; ij--) {
            if (~ignoreBtns.indexOf(name)) continue;
            item = menuBtns[ij];
            if (item.isActive) item.isActive = false;
            if (item.routerName === name) {
                item.isActive = true;
                has = true;
            }
        }
        if (has) dispatch('comon/updateMenuBtns', menuBtns);
        else {
            if (!~ignoreBtns.indexOf(name)) {
                dispatch(
                    'comon/updateMenuBtns',
                    menuBtns.concat({
                        name: meta.title,
                        routerName: name,
                        isActive: true,
                        needDelIcon: ignoreDelIconBtns.indexOf(name) === -1,
                    })
                );
            }
        }
    }
    if (meta.title) document.title = `${packageInfo.title}-${meta.title}`;
    let userInfo = state.comon.userInfo;

    if (Object.keys(userInfo).length === 0) {
        userInfo = localStorage.getItem('userInfo');
        userInfo = userInfo ? JSON.parse(userInfo) : {};
    }
    if (
        !userInfo.token &&
        to.path !== '/login' &&
        to.path !== '/git-version-info'
    ) {
        return next('/login');
    }
    // 线上环境使用version.json判断版本号
    if (process.env.NODE_ENV === 'production') {
        const data = await getPackageVersion();
        const localVersion = getLocal('SANY_ERP_VERSION');
        if (!localVersion) {
            setLocal('SANY_ERP_VERSION', data.version);
            next();
            return;
        }
        if (localVersion && localVersion !== data.version) {
            setLocal('SANY_ERP_VERSION', data.version);
            window.location.reload();
            return;
        }
    }
    next();
});

// 发生code-split模块读取错误时，使用重定向
router.onError((err) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = err.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});
